import firebase from 'firebase';

// var firebaseConfig = {
//     apiKey: "AIzaSyClajLUJ9dtkQGZTuFgdhp-MGUIYAhee-g",
//     authDomain: "globalfoxtrade-e6d8d.firebaseapp.com",
//     databaseURL: "https://globalfoxtrade-e6d8d-default-rtdb.firebaseio.com",
//     projectId: "globalfoxtrade-e6d8d",
//     storageBucket: "globalfoxtrade-e6d8d.appspot.com",
//     messagingSenderId: "821767893108",
//     appId: "1:821767893108:web:a17220a7fd486a60226121"
// };

const firebaseConfig = {
    apiKey: "AIzaSyBWGJNVU7LrpWcM8dvfissDRDwBsEix9q0",
    authDomain: "eliteprotrades.firebaseapp.com",
    databaseURL: "https://eliteprotrades-default-rtdb.firebaseio.com",
    projectId: "eliteprotrades",
    storageBucket: "eliteprotrades.appspot.com",
    messagingSenderId: "529013228719",
    appId: "1:529013228719:web:45d0bc92271ded7743c05a"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.firestore().settings({ timestampsInSnapshots: true })

export const f = firebase;
export const database = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
export default firebase.firestore()


